<template>
    <div id="all-tips-page" class="gradbg">
        <div class="header-panel">
            <h1>Savings Tips</h1>
        </div>
        <div class="list-panel">
            <ul>
                <li v-for="(tip, index) in tips" :key="index">
                    <p>{{ tip.heading }}</p>
                    <p>{{ tip.text }}</p>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: 'all-tips-page',
    data() {
        return {
            tips: [],
        }
    },
    methods: {
        async getTips() {
            let r = await fetch('https://fisential.com/fake-data/tips.json')
            this.tips = await r.json()
        }
    },
    created() {
        this.getTips()
    }
}
</script>
<style lang="scss">
#all-tips-page {
    .list-panel {
        flex: 1 1 100%;
        background: white;

        ul {
            li {
                border-bottom: solid 1px #DFE2E5;
                text-align: left;

                padding: 16px 20px;
                p {
                    &:first-child {
                        margin-bottom: 8px;
                    }
                    font-size: 13px;
                    font-weight: bold;
                    color: black;
                }
            }
        }
    }
}
</style>
